export const DEPOSIT_STAGES = [
  "signing",
  "confirming",
  "crediting",
  "complete",
] as const

export const DEPOSIT_STAGES_SHORT = [
  "signing",
  "confirming",
  "complete",
] as const

export type DepositDisplayStage = (typeof DEPOSIT_STAGES)[number]

export type DepositStage =
  | "signing"
  | "confirming"
  | "crediting"
  | "complete"
  | "error"

/**
 * Creates chain-specific stage labels.
 * e.g. "Confirming on Ethereum" instead of "Confirming on chain"
 */
export function getDepositStageLabels(
  chainLabel: string
): Record<DepositDisplayStage, string> {
  return {
    signing: "Signing transaction",
    confirming: `Confirming on ${chainLabel}`,
    crediting: "Crediting to account",
    complete: "Funds available",
  }
}

export function getDepositStageLabelsShort(
  chainLabel: string
): Record<DepositDisplayStage, string> {
  return {
    signing: "Signing",
    confirming: `Confirming on ${chainLabel}`,
    crediting: "Crediting",
    complete: "Available",
  }
}
